import json2mq from 'json2mq';

import { PrismaBreakpoints } from './types';

type IBreakpoints = string[] & Partial<PrismaBreakpoints>;

const screenMediaQueryArray = [
  ['md', '768px'],
  ['lg', '1200px'],
];

const breakpoints: IBreakpoints = screenMediaQueryArray.reduce(
  (result, [breakpoint, value]) => {
    result.push(value);
    result[breakpoint] = value;
    return result;
  },
  []
);

export const mediaQueries = [
  json2mq({ screen: true, minWidth: breakpoints.md }),
  json2mq({ screen: true, minWidth: breakpoints.lg }),
];

export const screenMediaQueries = screenMediaQueryArray.reduce(
  (result, [breakpoint, value]) => {
    const mq = `@media screen and (min-width: ${value})`;
    return result.set(breakpoint, mq);
  },
  new Map()
);

export default breakpoints;
